export const BATCH_LOADING = 'BATCH_LOADING';
export const BATCH_FULFILLED = 'BATCH_FULFILLED';
export const BATCHES_FULFILLED = 'BATCHES_FULFILLED';
export const BATCH_EXPENSE_HISTORY_FULFILLED = 'BATCHES_EXPENSE_HISTORY_FULFILLED';
export const BATCH_RETURN_HISTORY_FULFILLED = 'BATCHES_RETURN_HISTORY_FULFILLED';
export const BATCH_FEE_HISTORY_FULFILLED = 'BATCHES_FEE_HISTORY_FULFILLED';
export const BATCH_EXPENSE_CATEGORY_FULFILLED = 'BATCHES_EXPENSE_CATEGORY_FULFILLED';
